import { memo } from 'react';
import clsx from 'clsx';
import { BetaBadge } from '../shared';
import TEXT from './generated/TEXT/QuickSearchNlpResultsFooter';
import styles from './QuickSearchNlpResultsFooter.module.css';

TEXT.DEFINE({
  /** Description of AI-powered search shown in the footer of AI results */
  aiPoweredDescription: 'AI search surfaces results that go beyond keywords.',
});

type QuickSearchNlpResultsFooterProps = {
  inline?: boolean;
};

export const QuickSearchNlpResultsFooter = memo(
  ({ inline = false }: QuickSearchNlpResultsFooterProps) => {
    const content = (
      <span
        className={clsx(styles.footerContent, {
          [styles.footerContentInline]: inline,
        })}
      >
        <span
          className={clsx(styles.footerDescription, {
            [styles.footerDescriptionInline]: inline,
          })}
        >
          {TEXT.aiPoweredDescription}
        </span>
        <span className={styles.betaBadgeContainer}>
          <BetaBadge />
        </span>
      </span>
    );

    if (inline) {
      return content;
    }

    return <div className={styles.footerContainer}>{content}</div>;
  }
);

QuickSearchNlpResultsFooter.displayName = 'QuickSearchNlpResultsFooter';
